import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaBolt, FaHourglassHalf, FaBomb, FaCoins } from 'react-icons/fa';

const PowerupNotification = ({ type, onComplete }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(onComplete, 300);
    }, 2000);
    return () => clearTimeout(timer);
  }, [onComplete]);

  const getPowerupInfo = () => {
    switch (type) {
      case 'combo': return { icon: FaBolt, text: '2倍連擊加成!', color: 'from-purple-500 to-indigo-600', emoji: '⚡' };
      case 'time': return { icon: FaHourglassHalf, text: '+5秒時間!', color: 'from-cyan-500 to-blue-600', emoji: '⏰' };
      case 'bomb': return { icon: FaBomb, text: '爆炸效果!', color: 'from-red-500 to-orange-600', emoji: '💥' };
      case 'gold': return { icon: FaCoins, text: '+50分!', color: 'from-yellow-400 to-orange-500', emoji: '🌟' };
      default: return { icon: FaBolt, text: '道具激活!', color: 'from-pink-500 to-purple-600', emoji: '✨' };
    }
  };

  const info = getPowerupInfo();
  const Icon = info.icon;

  return (
    <div className="fixed top-32 left-0 w-full flex justify-center pointer-events-none z-[150]">
      <AnimatePresence>
        {isVisible && (
          <motion.div
            initial={{ scale: 0, y: -100, opacity: 0 }}
            animate={{ scale: 1, y: 0, opacity: 1 }}
            exit={{ scale: 0, y: 100, opacity: 0 }}
            transition={{ type: 'spring', damping: 20, stiffness: 300 }}
          >
            <div className={`bg-gradient-to-r ${info.color} text-white px-8 py-4 rounded-2xl shadow-2xl flex items-center gap-4 border-3 border-white`}>
              <motion.div
                animate={{ rotate: 360, scale: [1, 1.2, 1] }}
                transition={{ duration: 0.6, repeat: Infinity }}
                className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center"
              >
                <Icon size={24} />
              </motion.div>
              <div>
                <div className="text-2xl font-black flex items-center gap-2">
                  <span>{info.emoji}</span>
                  <span>{info.text}</span>
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default PowerupNotification;